import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { NonLifeInsuranceType } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceTypes";
import { CreateNonLifeInsuranceForm } from "web_myplann/Portfolio/Pages/NonLifeInsuranceCreate/CreateNonLifeInsuranceForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

type AddNonLifeInsurancePageProps = {
	insuranceType: NonLifeInsuranceType;
};

export const AddNonLifeInsurancePage = ({
	insuranceType,
}: AddNonLifeInsurancePageProps) => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout
			title={t(Resources.Portfolio.AddNonLifeInsurance.Titles[insuranceType])}
		>
			<CreateNonLifeInsuranceForm insuranceType={insuranceType} />
		</PortfolioAddLayout>
	);
};
